import { render, staticRenderFns } from "./EngagementDetailsPage.vue?vue&type=template&id=ddacdb88&scoped=true"
import script from "./EngagementDetailsPage.vue?vue&type=script&lang=js"
export * from "./EngagementDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./EngagementDetailsPage.vue?vue&type=style&index=0&id=ddacdb88&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddacdb88",
  null
  
)

export default component.exports